import { render } from "./ImagesBuilding.vue?vue&type=template&id=98f5b844"
import script from "./ImagesBuilding.vue?vue&type=script&lang=js"
export * from "./ImagesBuilding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__